import React, { Component } from "react";
import { Link } from "react-router-dom";
import Testimonials from "../Testimonials/Testimonials";
import "./Overview.css";

class Overview extends Component {
  flagshipProjects = [
    {
      title: "Skills for Londoners",
      funder: "Mayor of London",
      description:
        "Free training and ESOL programmes for diverse communities across East London.",
      link: "/about/our-impact",
    },
    {
      title: "Young People Coding & AI Camp",
      funder: "Barking & Dagenham Council",
      description:
        "Exposing young people to AI and software engineering, led by industry professionals.",
      link: "/community-projects/ncil-youth-coding-camp",
    },
    {
      title: "DWP Employment Plus",
      funder: "European Social Fund Agency",
      description:
        "Employment support and business upskilling programme delivered in 2018.",
      link: "/about/our-impact",
    },
  ];

  render() {
    return (
      <div className="overview-container">
      <div className="overview-header">
        <h1>Alisar Prospects Training</h1>
        <h3>
          Building blocks to your success{" "}
          <img
            src="https://img.icons8.com/ios-glyphs/80/000000/stairs-up.png"
            alt="stairs"
          />
        </h3>
        <p className="overview-lead">
          Practical education, employment support, and community advocacy for
          people across East and North London.
        </p>
      </div>
      
      <div className="overview-content">
          <h2>Welcome to Your Community</h2>
          <p className="subheading-text">
            Since 2013, Alisar Prospects Training has been a lifeline for
            London's most marginalized communities - asylum seekers finding
            their voice in a new language, single parents building careers while
            raising families, long-term unemployed discovering new paths, and
            refugees rebuilding lives with dignity.
            <br />
            <br />
            We're not just a training provider - we're your neighbors,
            advocates, and partners in navigating life's challenges. Whether you
            need to learn English, find employment, challenge an unfair
            eviction, or simply connect with others who understand your journey,
            we're here.
            <br />
            <br />
            Our approach is simple: everyone deserves access to quality education 
            and employment opportunities, regardless of their background or circumstances. 
            We work closely with local authorities, charities, and employers to create 
            pathways that lead to real, sustainable outcomes. From your first conversation 
            with our team to completing your programme and beyond, we walk alongside you 
            every step of the way. Join the hundreds of community members who have already 
            transformed their lives through our free programmes and support services.
          </p>

          <h3>How Can We Support You?</h3>
          <div className="support-pillars-container">
            <Link to="/community-projects" className="support-pillar-card pillar-community">
              <div className="pillar-content">
                <span className="pillar-icon">🤝</span>
                <span className="pillar-title">Community Projects & Advocacy</span>
                <span className="pillar-arrow">→</span>
              </div>
            </Link>
            
            <Link to="/training" className="support-pillar-card pillar-education">
              <div className="pillar-content">
                <span className="pillar-icon">📚</span>
                <span className="pillar-title">Education & Training</span>
                <span className="pillar-arrow">→</span>
              </div>
            </Link>

            <Link to="/employment-support" className="support-pillar-card pillar-employment">
              <div className="pillar-content">
                <span className="pillar-icon">💼</span>
                <span className="pillar-title">Employment & Entrepreneurship</span>
                <span className="pillar-arrow">→</span>
              </div>
            </Link>
          </div>
          
          <Link to="/contact" className="body-button">
            <div className="body-btn-circle"></div>
            <span>Contact Us</span>
          </Link>
        </div>

        <div className="overview-subcontent">
          {/* Flagship Projects */}
          <div className="flagship-highlight">
            <h3 className="subcontent-header">
              <span>Flagship Projects</span>
            </h3>
            <ul className="flagship-list">
              {this.flagshipProjects.map((project, index) => (
                <li key={index}>
                  <Link to={project.link}>
                    <div className="flagship-card">
                      <span className="flagship-funder">{project.funder}</span>
                      <h4 className="flagship-title">→ {project.title}</h4>
                      <p className="flagship-desc">{project.description}</p>
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
            <ul style={{ marginTop: '20px' }}>
              <li>
                <Link to="/about/our-impact">View All Our Impact</Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="subcontent-header testimonial-header">
              <span>Community Voices</span>
            </h3>
            <div className="testimonial-container">
              <Testimonials />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Overview;
